import React from 'react';

/**
 * Controls - Time controls, dose controls, scenario toggles, interventions, and mode toggle.
 */
const Controls = ({
  isRunning,
  speed,
  onTogglePlay,
  onSetSpeed,
  onAdministerDose,
  onToggleModifier,
  onActivateIntervention,
  onReset,
  onToggleMode,
  advancedMode,
  scenario,
  simState,
  isComplete,
}) => {
  const getName = (item) => {
    if (!advancedMode && item.simpleName) return item.simpleName;
    return item.name || item.label;
  };

  return (
    <div className="controls-panel">
      {/* Time Controls */}
      <div className="control-group">
        <h3>Time</h3>
        <div className="button-row">
          <button
            className={`btn ${isRunning ? 'btn-warning' : 'btn-primary'}`}
            onClick={onTogglePlay}
            disabled={isComplete}
          >
            {isRunning ? '⏸ Pause' : '▶ Play'}
          </button>
          {[1, 2, 4].map(s => (
            <button
              key={s}
              className={`btn btn-small ${speed === s ? 'btn-active' : ''}`}
              onClick={() => onSetSpeed(s)}
            >
              {s}x
            </button>
          ))}
        </div>
        <button className="btn btn-reset" onClick={onReset} style={{ marginTop: '8px' }}>
          ↻ Reset Simulation
        </button>
      </div>

      {/* Dose Controls */}
      <div className="control-group">
        <h3>Dose</h3>
        <div className="button-column">
          {scenario.dosePresets.map((preset, i) => (
            <button
              key={i}
              className="btn btn-dose"
              onClick={() => onAdministerDose(preset.amount)}
              disabled={isComplete}
            >
              {getName(preset)} ({preset.amount})
            </button>
          ))}
        </div>
      </div>

      {/* Scenario Toggles */}
      <div className="control-group">
        <h3>Scenario</h3>
        {scenario.modifiers.map(mod => (
          <label key={mod.id} className="toggle-label">
            <input
              type="checkbox"
              checked={simState?.modifiers[mod.id] || false}
              onChange={(e) => onToggleModifier(mod.id, e.target.checked)}
              disabled={isComplete}
            />
            <span className="toggle-text">
              {getName(mod)}
              <span className="toggle-description">{mod.description}</span>
            </span>
          </label>
        ))}
      </div>

      {/* Interventions */}
      <div className="control-group">
        <h3>Interventions</h3>
        {scenario.interventions.map(intervention => {
          const isActive = simState?.interventions[intervention.id]?.active;
          return (
            <button
              key={intervention.id}
              className={`btn btn-intervention ${isActive ? 'btn-active' : ''}`}
              onClick={() => onActivateIntervention(intervention.id)}
              disabled={isActive || isComplete}
            >
              {isActive ? '✓ ' : ''}{getName(intervention)}
            </button>
          );
        })}
      </div>

      {/* Mode Toggle */}
      <div className="control-group">
        <h3>Display</h3>
        <label className="toggle-label">
          <input
            type="checkbox"
            checked={advancedMode}
            onChange={onToggleMode}
          />
          <span className="toggle-text">
            Advanced Mode
            <span className="toggle-description">
              Show biochemical names instead of simplified labels
            </span>
          </span>
        </label>
      </div>

    </div>
  );
};

export default Controls;
